import React from 'react'
import uuid from 'uuid'

// TODO(Igor): Review usage and implementation of useUniqueId. It does not seem to be SSR-friendly. After we
// migrate to React 18 we should replace it with https://reactjs.org/docs/hooks-reference.html#useid
export function useUniqueId(): string {
  // prepend an "a" so that this'll for sure be a valid HTML id
  const id = `a${uuid.v4()}`
  const idRef = React.useRef(id)
  return idRef.current
}
